import BulkMessageModalAbstract from './bulk-message-modal-abstract';

export default class VoucherBulkMessageModalController extends BulkMessageModalAbstract {

    _getParametersForTemplatesStore() {
        return {
            ...super._getParametersForTemplatesStore(),
            onlyGlobal: true
        };
    }

    _getDisplayStoreFields() {
        return [
            'voucher_number',
            'contact.id',
            'contact.full_name',
            'contact.preferred_email',
            'contact.company_name',
            'contact.profile_image'
        ];
    }

    _getDisplayStoreSort() {
        return {
            'voucher_number': 'asc'
        };
    }

    _formatDisplayRow(row, index) {
        return {
            ...super._formatDisplayRow(row, index),
            voucher_number: row.voucher_number ? row.voucher_number : '',
            name: row.contact.full_name ? row.contact.full_name : row.contact.company_name,
            company: (_.isUndefined(row.contact.company_name) ? '' : row.contact.company_name) + '',
            image_url: row.contact.profile_image.thumbnail,
            email: row.contact.preferred_email
        };
    }

    _prepareRecipientPostData() {
        return {
            recipient_type: 'voucher',
            vouchers: this.recipientsStore.getters.selectedFilters
        }
    }

    _getPreviewUrl(recipient) {
        return `templates/${this.selectedTemplateId}/preview/voucher/${recipient.id}`;
    }
}



// WEBPACK FOOTER //
// ./src/app/modules/messages/controllers/modals/bulk-send/voucher-bulk-message-modal.js